import React from 'react';
import { Info, MoreVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SimpleHeaderProps {
  text: string;
}

const SimpleHeader: React.FC<SimpleHeaderProps> = ({ text }) => (
  <div>
    <div className="flex items-center justify-between py-2">
      <span className="flex items-center gap-2">
        <span className="text-lg font-medium">{text}</span>
        <Info className="w-4 h-4 text-gray-500" />
      </span>
      <Button variant="ghost" size="icon" className="text-gray-400 h-0 ">
        <MoreVertical className="w-4 h-4" />
      </Button>
    </div>
    <hr className="border-gray-200 mb-2" />
  </div>
);

export default SimpleHeader; 